import { AssertionProcessDetailsPage } from '@/components/assertion-dashboard/AssertionProcessDetailsPage';
import type { VerificationAssertionResultFilter } from '@/core/model/assertion-verification-result';
import { createFileRoute } from '@tanstack/react-router';
import * as v from 'valibot';

export const Route = createFileRoute(
  '/_authenticated/assertion/process/$processId',
)({
  component: AssertionProcessDetailsPage,
  validateSearch: v.object({
    resultsFilter: v.optional(
      v.picklist([
        'all',
        'correct',
        'attention',
        'proofreading_failed',
        'customer_approval_requested',
      ] satisfies VerificationAssertionResultFilter[]),
      'all',
    ),
    resultsPage: v.optional(v.number(), 0),
  }),
});
